/**
 * Custom js for main menu. 
 *
 * @since		12/1/2020
 * @author		<john@chatmandesign.com>
 * @link		http://chatmandesign.com
 */
(function($) {
    // Selectors
    let mobileSlideClass = 'mobile-slide-menu';
    let mobileSlide = '.' + mobileSlideClass;
    let mainHamburger = '.main-hamburger';

    // Functions

    function mobileSlideBodyAppend() {
        $(mobileSlide).appendTo('body');
    }

    function mobileSlideIn() {
        $(mobileSlide).show();
        // Makes sure transition is seen
        setTimeout(function(){
            $(mobileSlide).addClass('slide-in'); 
        }, 10); 
    }

    function mobileSlideOut() {
        $(mobileSlide).removeClass('slide-in'); 
        // 500ms for header-transition
        setTimeout(function() {
            $(mobileSlide).hide();
        }, 500); 
    }

    //! – DOM READY
    $(function() {
        if( $(mobileSlide).length ) {
            mobileSlideBodyAppend();

            // Fade and slide in on hamburger click
            $(mainHamburger).on('click', function(event){
                event.preventDefault();
                mobileSlideIn();
            });

            // Slide and fade out on overlay click
            $(mobileSlide).on('click', function(event){
                let eventClassName = event.target.className;
                if( eventClassName.includes(mobileSlideClass) ){
                    mobileSlideOut();
                }
            });
        }
    }); // DOM READY 

})(jQuery);
